"use strict";
export default {
  changePage(model, direction) {
    event.preventDefault();
    event.stopPropagation();
    const index = this.currentPageIndex(model);
    if (index < 0) return;
    const desiredIndex = direction === "next" ? index + 1 : index - 1;
    this.goToPageAtIndex(desiredIndex, model);
  },
  allPages: function(model) {
    return _.chain(model.activeDocuments()).map((d) => d.pages).flatten().value();
  },
  currentPageIndex: function(model) {
    return _.findIndex(
      this.allPages(model),
      (p) => model.selectedPage.id === p.id
    );
  },
  goToPageAtIndex: function(i, model) {
    const desiredPage = this.allPages(model)[i];
    if (desiredPage) {
      this.selectPage(desiredPage, model);
    }
  },
  selectPage: function(page, model) {
    model.selectPage(page);
  }
};
